import axios from "axios";
import * as URL from "../../helpers/Constants";

export default class PMSIncomeCategoryServices {

    static createIncomeCategoryByPharmacyId(id, data) {
        return axios.post(`${URL.PMS_CREATE_INCOME_CATEGORY_BY_PHARMACY_ID}/${id}`, data, PMSIncomeCategoryServices.getAuthHeader())
    }

    static getAllIncomeCategoriesByPharmacyId(id, params) {
        return axios.get(`${URL.PMS_READ_INCOME_CATEGORY_BY_PHARMACY_ID}/${id}`, {
            ...PMSIncomeCategoryServices.getAuthHeader(),
            params
        })
    }

    static getAuthHeader() {
        const accessToken = localStorage.getItem("oushodsheba_access_token");
        return { headers: { "Authorization": `Bearer ${accessToken}` } };
    }

}